import * as actionType from "./action";

export function globalMessageReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.SET_GLOBAL_MESSAGE_SUCCESS:
      return { ...state, response };
    case actionType.SET_GLOBAL_MESSAGE_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
